export var FastenCallbackMode;
(function (FastenCallbackMode) {
    FastenCallbackMode["LIVE"] = "live";
    FastenCallbackMode["TEST"] = "test";
})(FastenCallbackMode || (FastenCallbackMode = {}));
export var FastenCallbackEventType;
(function (FastenCallbackEventType) {
    FastenCallbackEventType["CONNECTION_PENDING"] = "patient.connection_pending";
    FastenCallbackEventType["CONNECTION_SUCCESS"] = "patient.connection_success";
    FastenCallbackEventType["CONNECTION_FAILED"] = "patient.connection_failed";
    FastenCallbackEventType["WIDGET_COMPLETE"] = "widget.complete";
})(FastenCallbackEventType || (FastenCallbackEventType = {}));
